/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import "./user-profile.m.css";
import { SvgHandler } from "../svg-handler/svg-handler";
import defaultAuthorIcon from "../../../assets/icons/user-icon.svg";
import { UserData } from "./user-profile-data";

class UserProfile extends React.Component {
  toggleForm = event => {
    event.stopPropagation();
    event.preventDefault();
    this.props.openLoginTemplate();
  };

  render() {
    const { member, customCssClasses = "", logout, localizedSignIn } = this.props;
    return (
      <>
        {!member ? (
          <div onClick={event => this.toggleForm(event)} styleName={`sign-btn ${customCssClasses}`}>
            <span styleName="white-space" data-test-id="user-profile">
              <div styleName="sign-in-svg">
                <SvgHandler
                  xlinkHref={defaultAuthorIcon}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  svgWrapperClazzName="svg-wrapper"
                />
              </div>
              <div styleName="sign-in-btn">{localizedSignIn || "SIGN IN"}</div>
            </span>
          </div>
        ) : (
          <UserData logout={logout} customCssClasses={customCssClasses} />
        )}
      </>
    );
  }
}
UserProfile.propTypes = {
  member: PropTypes.object,
  openLoginTemplate: PropTypes.func,
  logout: PropTypes.func,
  customCssClasses: PropTypes.string,
  localizedSignIn: PropTypes.string
};

export { UserProfile };
